import { useEffect, useState,useMemo,  } from "react";
import { Form, Input } from 'antd-mobile'
import { useTranslation } from "react-i18next";
import {useNavigate} from 'react-router-dom'
import styles from "./index.module.scss";
import { useStore, waringMoneyProps } from "../../store/store";
import { updateWarnMoneyApi, getDefaultWarnMoneyApi,getRoomIdDefaultWarnMoneyApi } from "../../http/request";
import { modalConfirm, modalAlert } from "../../component/Modal/index";
type warinType = keyof waringMoneyProps

export default function Index() {
  const navigate = useNavigate()
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  const [defaultWarn, setDefaultWarn] = useState({
    coldWaterWarnMoney:0,
    eleWarnMoney: 0,
    hotWaterWarnMoney: 0
  })
  const {buildingid,meterList,waringMoney,nkdSid } =
  useStore((state) => state);
  const [meterOptions, setMeterOptions] = useState<any []>([])
  const [values, setValues] = useState(waringMoney)
  /**
   * @description 获取表计设置的默认提醒阈值
   */
  const getDefaultWarnMoney = async () => {
    const res = await getRoomIdDefaultWarnMoneyApi(buildingid)
    if (res.data.code == 0) {
       setDefaultWarn({
        coldWaterWarnMoney:res.data.coldWaterWarnMoney2,
    eleWarnMoney: res.data.eleWarnMoney2,
    hotWaterWarnMoney: res.data.hotWaterWarnMoney2,
      })
    }
  }

  /**
   * @description 确定设置
   */

  const updateWarnMoney = async () => {
    try {
      const values = await form.validateFields();
    } catch (errorInfo) {
      return
    }
    const res = await modalConfirm({
      title: t("TS"),
      content: t('QDSZ'),
      confirmText: t("QD"),
      cancelText: t("QX"),
    });
    if (res) {
      let newValues:any = {}
      Object.keys(values).forEach((key) => {
       if (values[key as warinType]) {
        newValues[key] =  Number(values[key as warinType]) 
       }
      }) 
      const result = await updateWarnMoneyApi({
        buildingID:buildingid,
        ...newValues
      })
      if (result.data.code == 0) {
        await modalAlert({
          title: t("TS"),
          content: t('SZCG'),
          confirmText: t("ZDL"),
        });
        return;
      }
      await modalAlert({
        title: t("TS"),
        content: result.data.msg,
        confirmText: t("ZDL"),
      });
      return;
    }
  }
  /**
   * @description 数据校验,规则 1-设置的阈值不能小于默认阈值的二级阈值。2-设置的二级阈值不能大于等于一级阈值, 3-可只设置单级
   */
  const validatorFun = (itemProps: Record<string, any>, value: string, param: any) => {
    const propName = itemProps.field
    const index = propName.slice(-1)
    const validTypes = propName.slice(0, -1)
    let validMessage: Promise<any> = Promise.resolve()
    let newVlue = Number(value)
    switch(validTypes) {
      case 'eleWarnMoney':
        if (value !== '') {
          if (newVlue < defaultWarn.eleWarnMoney) {
            return Promise.reject(new Error(t('MRFZ')))
          } 
          if (index == 1 && newVlue <= Number(values.eleWarnMoney2))  {
           return  Promise.reject(new Error(t('VALIDMESSAGE')))
          }
          if (index == 2 && values.eleWarnMoney1 !== '' && newVlue > Number(values.eleWarnMoney1))  {
            return  Promise.reject(new Error(t('VALIDMESSAGE')))
          }
        }
      index == 1 ? 
      setValues((params) =>({
        ...params,
        eleWarnMoney1: value
      })) : setValues((params) =>({
        ...params,
        eleWarnMoney2: value
      })) 
      break;
      case 'coldWaterWarnMoney':
        if (value !== '') {
          if (Number(value) < defaultWarn.coldWaterWarnMoney) {
            return Promise.reject(new Error(t('MRFZ')))
          } 
          if (index == 1 && newVlue <= Number(values.coldWaterWarnMoney2))  {
            return  Promise.reject(new Error(t('VALIDMESSAGE')))
           }
           if (index == 2 && values.coldWaterWarnMoney1 !== '' && newVlue > Number(values.coldWaterWarnMoney1)  )  {
             return  Promise.reject(new Error(t('VALIDMESSAGE')))
           }
        }
        index == 1 ? setValues((params) =>({
          ...params,
          coldWaterWarnMoney1: value
        })) : setValues((params) =>({
          ...params,
          coldWaterWarnMoney2: value
        })) 
      break
      case 'hotWaterWarnMoney':
        if (value !== '') {
          if (Number(value) < defaultWarn.hotWaterWarnMoney) {
            return Promise.reject(new Error(t('MRFZ')))
          } 
          if (index == 1 && newVlue <= Number(values.hotWaterWarnMoney2))  {
            return  Promise.reject(new Error(t('VALIDMESSAGE')))
           }
           if (index == 2 && newVlue > Number(values.hotWaterWarnMoney1))  {
             return  Promise.reject(new Error(t('VALIDMESSAGE')))
           }
        }
          index == 1 ? setValues((params) =>({
            ...params,
            hotWaterWarnMoney1: value
          })) : setValues((params) =>({
            ...params,
            hotWaterWarnMoney2: value
          })) 
      break
      default: {}
    }
   
    return validMessage
    }
    /**
   * @description 获取表计类型
   */
        const getMeterType = (type: string) => {
          let meterType = ''
          switch(type) {
            case '电表': meterType =  t('DIAN')
            break;
            case '冷水表': meterType =  t('SB1')
            break
            case '热水表': meterType =  t('SB2')
            break
            default: {}
          }
          return meterType
        }
    /**
     * @description 获取form.item name值
     */
  const getValiKeyValue = (type: string, index?: number): Record<string, string> => {
    let name
    let meterType = ''
    let placeholder = ''
    switch(type) {
      case '电表': name = index == 1 ? 'eleWarnMoney1': 'eleWarnMoney2'
      meterType =  t('DIAN')
      placeholder = `${t('XTMR')}${defaultWarn.eleWarnMoney}${t('MONETARY_UNIT')}`
      break;
      case '冷水表': name = index == 1 ? 'coldWaterWarnMoney1': 'coldWaterWarnMoney2'
      meterType =  t('SB1')
      placeholder = `${t('XTMR')}${defaultWarn.coldWaterWarnMoney}${t('MONETARY_UNIT')}`
      break
      case '热水表': name =  index == 1 ? 'hotWaterWarnMoney1': 'hotWaterWarnMoney2'
      meterType =  t('SB2')
      placeholder = `${t('XTMR')}${defaultWarn.hotWaterWarnMoney}${t('MONETARY_UNIT')}`
      break
      default: {}
    }
    return {name: name as string, meterType,placeholder}
  }
  useEffect(() => {
    if (!nkdSid) {
      navigate('/login')
      return
    }
    if (buildingid) {
    getDefaultWarnMoney()
    }
    document.title = t('SZ')
    if (meterList.length> 0) {
      const options = meterList.map((item: Record<string, any>) => {
        return {value: item.monitorid, label:item.energyType}
      })
      setMeterOptions(options)
    }
  },[])
  return (
    <div className={styles.main_container}>
        <div style={{height: i18n.language == "en"? '48vw': '28vw'}} className={styles.Instructions}>
          <p>{t('SZ')}</p>
          <div className={styles.text}>
            {t('SM')}:
            &nbsp;{`${t('DDLSM')}${t('XTMR')}:${t('EL')}${defaultWarn.eleWarnMoney}${t('MONETARY_UNIT')};${t('LS')}${defaultWarn.coldWaterWarnMoney}${t('MONETARY_UNIT')};${t('RS')}${defaultWarn.hotWaterWarnMoney}${t('MONETARY_UNIT')}`}
          </div>
        </div>
        <div className={styles.content_container}>
      {meterOptions.length> 0? 
      (
        <Form  form={form} layout='vertical' initialValues={values}>
          { meterOptions.length == 1?
          (
            <div>
                   <Form.Item validateTrigger="onBlur"    name={getValiKeyValue(meterOptions[0].label, 1).name}  label={getValiKeyValue(meterOptions[0].label).meterType} extra={
              <div className={styles.extraPart}>
                {t('MONETARY_UNIT')}
              </div>
            } 
            rules={[
              {validator: validatorFun}
            ]}
            >
                 <Input type="number"   placeholder={t('L1')} style={{height: '10px','--font-size':'14px'}}  clearable />
               </Form.Item>
               <Form.Item  validateTrigger="onBlur" name={getValiKeyValue(meterOptions[0].label,  2).name} extra={
              <div className={styles.extraPart}>
                {t('MONETARY_UNIT')}
              </div>
            } 
            rules={[
              {validator: validatorFun}
            ]}
            >
                 <Input type="number"    placeholder={getValiKeyValue(meterOptions[0].label, 1).placeholder} style={{height: '10px','--font-size':'14px'}} clearable  />
               </Form.Item>
          </div>  
          ): ( meterOptions.length == 2? (
            <div>
  <Form.Item validateTrigger="onBlur" rules={[
              {validator: validatorFun}
            ]}   name={getValiKeyValue(meterOptions[0].label, 1).name} label={getMeterType(meterOptions[0].label)} extra={
              <div className={styles.extraPart}>
                {t('MONETARY_UNIT')}
              </div>
            } >
            <Input type="number"   placeholder={t('L1')} style={{height: '10px','--font-size':'14px'}}  clearable />
          </Form.Item>
          <Form.Item  rules={[
              {validator: validatorFun}
            ]} extra={
              <div className={styles.extraPart}>
                {t('MONETARY_UNIT')}
              </div>
            }
            validateTrigger="onBlur" name={getValiKeyValue(meterOptions[0].label, 2).name}
            >
            <Input type="number"   placeholder={getValiKeyValue(meterOptions[0].label, 1).placeholder} style={{height: '10px','--font-size':'14px'}} clearable  />
          </Form.Item>
          <Form.Item  label={getMeterType(meterOptions[1].label)} extra={
              <div className={styles.extraPart}>
                {t('MONETARY_UNIT')}
              </div>
            }
            validateTrigger="onBlur"    name={getValiKeyValue(meterOptions[1].label, 1).name} rules={[
              {validator: validatorFun}
            ]}
            >
            <Input type="number"   placeholder={t('L1')} style={{height: '10px','--font-size':'14px'}}  clearable />
          </Form.Item>
          <Form.Item  extra={
              <div className={styles.extraPart}>
                {t('MONETARY_UNIT')}
              </div>
            }
            validateTrigger="onBlur"    name={getValiKeyValue(meterOptions[1].label,  2).name} rules={[
              {validator: validatorFun}
            ]}
            >
            <Input type="number"    placeholder={getValiKeyValue(meterOptions[1].label, 1).placeholder} style={{height: '10px','--font-size':'14px'}} clearable  />
          </Form.Item>
            </div>
          ):(
            <div>
            <Form.Item validateTrigger="onBlur" rules={[
                        {validator: validatorFun}
                      ]}   name={getValiKeyValue(meterOptions[0].label, 1).name} label={getMeterType(meterOptions[0].label)} extra={
                        <div className={styles.extraPart}>
                          {t('MONETARY_UNIT')}
                        </div>
                      } >
                      <Input type="number"   placeholder={t('L1')} style={{height: '10px','--font-size':'14px'}}  clearable />
                    </Form.Item>
                    <Form.Item  rules={[
                        {validator: validatorFun}
                      ]} extra={
                        <div className={styles.extraPart}>
                          {t('MONETARY_UNIT')}
                        </div>
                      }
                      validateTrigger="onBlur" name={getValiKeyValue(meterOptions[0].label,  2).name}
                      >
                      <Input type="number"   placeholder={getValiKeyValue(meterOptions[0].label, 1).placeholder} style={{height: '10px','--font-size':'14px'}} clearable  />
                    </Form.Item>
                    <Form.Item  label={getMeterType(meterOptions[1].label)} extra={
                        <div className={styles.extraPart}>
                          {t('MONETARY_UNIT')}
                        </div>
                      }
                      validateTrigger="onBlur"    name={getValiKeyValue(meterOptions[1].label, 1).name} rules={[
                        {validator: validatorFun}
                      ]}
                      >
                      <Input type="number"   placeholder={t('L1')} style={{height: '10px','--font-size':'14px'}}  clearable />
                    </Form.Item>
                    <Form.Item  extra={
                        <div className={styles.extraPart}>
                          {t('MONETARY_UNIT')}
                        </div>
                      }
                      validateTrigger="onBlur"    name={getValiKeyValue(meterOptions[1].label,  2).name} rules={[
                        {validator: validatorFun}
                      ]}
                      >
                      <Input type="number"    placeholder={getValiKeyValue(meterOptions[1].label, 1).placeholder} style={{height: '10px','--font-size':'14px'}} clearable  />
                    </Form.Item>
                    <Form.Item label={getMeterType(meterOptions[2].label)} extra={
              <div className={styles.extraPart}>
                {t('MONETARY_UNIT')}
              </div>
            }
            validateTrigger="onBlur"    name={getValiKeyValue(meterOptions[2].label, 1).name} rules={[
              {validator: validatorFun}
            ]}
            >
                   <Input type="number"  placeholder={t('L1')} style={{height: '10px','--font-size':'14px'}}  clearable />
                 </Form.Item>
                 <Form.Item  extra={
              <div className={styles.extraPart}>
                {t('MONETARY_UNIT')}
              </div>
            }
            validateTrigger="onBlur"    name={getValiKeyValue(meterOptions[2].label,  2).name} rules={[
              {validator: validatorFun}
            ]}
            >
                   <Input type="number"  placeholder={getValiKeyValue(meterOptions[2].label, 1).placeholder} style={{height: '10px','--font-size':'14px'}} clearable  />
                 </Form.Item>
                      </div>
          ))
        }
    </Form>): null}
          <div className={styles.footer}>
            <div onClick={() => {
              navigate('/')
            }} className={styles.botten_view}>{t('QX')}</div>
            <div onClick={updateWarnMoney} className={styles.botten_view} style={{background:' linear-gradient(90deg, #00B676, #00A796)',color:' #FFFFFF'
          }}>{t('QD')}</div>
          </div>
        </div>
    </div>
  );
}
